import React from 'react';

import {
    Stack,
    Typography
} from '@mui/material';

import {
    Text
} from 'components';

const styles = {

    root: {
        paddingY: 2.5
    },
};

const Information = ({team}) => {
    return (
        <Stack sx={styles.root}>
            <Stack>
                <Stack>
                    <Typography color="grey.mainlight"><Text>global.name</Text></Typography>
                </Stack>
                <Stack>
                    {team.name ?
                        <Typography color="grey.mainlight2">{team.name}</Typography> :
                        <Typography color="grey.mainlight2"><Text>ui.placeholder.textfield</Text></Typography>
                    }
                </Stack>
            </Stack>
        </Stack>
    );
};

export default Information;